/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

export const salesKeys = {
  list: (agencyId: string, state: string) => ['sales', agencyId, 'list', state] as const,
  detail: (agencyId: string, saleId: string) => ['sales', agencyId, 'detail', saleId] as const,
  commission: (agencyId: string, saleId: string) =>
    ['sales', agencyId, 'commission', saleId] as const,
  documents: (agencyId: string, saleId: string) =>
    ['sales', agencyId, 'documents', saleId] as const,
  milestoneTypes: (agencyId: string) => ['sales', agencyId, 'milestone-types'] as const,
  settings: (agencyId: string) => ['sales', agencyId, 'settings'] as const,
};
